import Button from '@material-ui/core/Button';

export default function MailVerifiedInfo(props) {
    return props.mailVerified ? 
    <span className="highlighted-text">Email verified</span> : 
    <><span className="warning">Email not verified</span> <Button className="QuanButton SmallButton LongButton" variant="contained" color="primary">Send Code</Button> </>;
}